import {
    SELECT_SHIPPING_OPTION,
    NOTIFY_REFRESHING_SHIPPING_OPTIONS,
    NEW_SHIPPING_OPTIONS,
    fetchJson
} from '../../GlobalStateContainer'
import { notifyError } from "../UserMessaging";
/* SHIPPING METHOD */

export function selectShippingMethod(shippingMethodId) {
    return { type: SELECT_SHIPPING_OPTION, shippingMethodId }
}

export function notifyRefreshingShippingOptions() {
    return { type: NOTIFY_REFRESHING_SHIPPING_OPTIONS }
}

export function setNoShippingOptionsForInvalidAddress() {
    return { type: NEW_SHIPPING_OPTIONS, shippingOptions: [] }
}

const isAllUniqueValues = (arr) => [...new Set(arr)].length === arr.length

const shippingOptionsAreInvalid = (shippingOptions) => {
    if (!isAllUniqueValues(shippingOptions.map(so => so.Id))) {
        console.error();
        return 'not all Ids unique for ShippingOptions';
    }
    return null;
}

const onRefreshShippingOptionsSuccess = ({ shippingOptions }) => {
    const invalidMessage = shippingOptionsAreInvalid(shippingOptions);
    if (invalidMessage)
        return notifyError("An error occurred retrieving shipping options.", invalidMessage)

    return { type: NEW_SHIPPING_OPTIONS, shippingOptions }
}

const refreshShippingOptionsAsyncSpec = {
    endpoint: (state) => state.constants.navigation.refreshShippingOptionsEndpoint,
    init: { method: 'POST', credentials: 'same-origin' },
    notify: notifyRefreshingShippingOptions,
    extract: (response) => response.json(),
    onSuccess: onRefreshShippingOptionsSuccess,
    onError: (diagMsg) => notifyError('An error occurred refreshing the shipping methods', diagMsg)
}

export const refreshShippingOptionsAsync = fetchJson(refreshShippingOptionsAsyncSpec)